import type { ShopProductsResponseDto } from "~/common/interfaces/dto/shop/shop-products-response.dto";

export const getProductDefault = (): ShopProductsResponseDto => ({
	id: 0,
	name: "",
	description: "",
	kind: {
		id: 0,
		name: "",
		translations: []
	},
	materialIds: [],
	sizeIds: [],
	tags: [],
	imageIds: []
});
